import { Component, OnDestroy, OnInit } from '@angular/core';
import { GridOptions, GridReadyEvent } from 'ag-grid';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { Subscription } from 'rxjs/Subscription';
import { ServiceProviderService } from '../../../../core/services/service-provider.service';
import { BooleanCheckComponent } from '../../../A2-utils/grid-components/boolean-check/boolean-check.component';
import { IServiceProvider } from 'app/core/interfaces/service-provider.interface';

@Component({
  selector: 'app-list-service-provider',
  templateUrl: './list-service-provider.component.html',
  styleUrls: ['./list-service-provider.component.scss']
})
export class ListServiceProviderComponent implements OnInit, OnDestroy {

  gridServiceProvider: GridOptions;
  currentPage = 1;
  description = '';
  totalPages: number;
  paginatorData = {};
  showDisabled = false;
  searchValue = null;

  private subscriptions: Subscription[] = [];

  constructor(private serviceProviderService: ServiceProviderService,
    private sweetAlertHelper: SweetAlertHelper,
  ) {
    this.initGrid();

    this.subscriptions.push(
      this.serviceProviderService.closeModalMergeServiProviders$.subscribe((value) => {
        if (value.isClose && value.refreshGrid) {
          this.onFilter();
        }
      })
    );

  }

  ngOnInit() {
    this.subscriptions.push(
      this.serviceProviderService.saveOnSuccessfull$.subscribe(() => {
        this.getListServiceProvider();
      }, error => {
        this.sweetAlertHelper.captureException(error);
      }),
      this.serviceProviderService.modalClosed$.subscribe((value) => {
        if (value) {
          this.getListServiceProvider(true);
        }
    })
    );
  }

  initGrid() {
    this.gridServiceProvider = <GridOptions>{
      rowSelection: 'multiple',
      enableSorting: true,
      enableColResize: true,
      enableFilter: true,
      columnDefs: [
        {
          colId: 'id',
          checkboxSelection: true,
          headerCheckboxSelection: true,
          width: 30,
        },
        {
          headerName: 'Service Provider Name',
          field: 'description',
          colId: 'description',
        },
        {
          headerName: 'SpeedCode',
          field: 'speedcode',
          colId: 'speedcode',
        },
        {
          headerName: 'Status',
          field: 'isactive',
          colId: 'isactive',
          cellRendererFramework: BooleanCheckComponent
        }
      ],
      onGridReady: (event: GridReadyEvent) => {
        this.getListServiceProvider();
      },
      onRowSelected: (event) => {
        this.rowSelected(event);
      },
      onRowDoubleClicked: (event) => {
        this.onSetSelected(event);
      }
    };
  }

  getListServiceProvider(restoreSelection = false) {
    const data: any = {
      rows: 20,
      page: this.currentPage,
      showinactive: this.showDisabled,
      description: this.description,
    };
    this.serviceProviderService.postByPage(data).subscribe((resp: any) => {
      this.totalPages = resp.totalpages;
      this.paginatorData = {
        currentPage: this.currentPage,
        totalPages: this.totalPages,
      };
      if (!this.gridServiceProvider.api) {
        return;
      }
      const nodes = this.gridServiceProvider.api.getSelectedNodes();
      if (!nodes && !nodes.length) {
        return;
      }
      const selectedIds = nodes.map(n => n.data.serviceproviderid);
      const filter = this.gridServiceProvider.api.getFilterModel();
      this.gridServiceProvider.api.setRowData(resp.data);
      if ( restoreSelection ) {
        this.gridServiceProvider.api.forEachNode(node => {
          const serviceProviderId  = node.data.serviceproviderid;
          if (serviceProviderId && selectedIds.includes(serviceProviderId)) {
            node.setSelected(true);
          }
        });
      }
      this.gridServiceProvider.api.setFilterModel(filter);
    });
  }

  onSetSelected(event: any) {
    const gridData = event.data;
    this.serviceProviderService.nextBehaviorServiceProvId(gridData.serviceproviderid);
  }

  onFilter() {
    if (this.searchValue && !!this.searchValue.trim().length) {
          this.description = this.searchValue.trim();
            if (this.totalPages < this.currentPage) {
              this.currentPage = 1;
              this.paginatorData = {
                currentPage: this.currentPage,
                totalPages: this.totalPages,
              };
            }
        this.getListServiceProvider();
    }
  }

  checkEmptyField() {
    if (!this.searchValue) {
      this.description = '';
      this.getListServiceProvider();
    }
  }

  paginator(event: any) {
    if (event) {
      this.currentPage = event;
      this.getListServiceProvider();
    }
  }

  rowSelected(event: any): void {
    const api = event.api;
    if (!api) {
      return;
    }

    const serviceProviderIds = api.getSelectedNodes()
      .map(({ data }) => ({
        serviceproviderid: data.serviceproviderid,
        description: data.description.trim() || '',
        speedcode: data.speedcode || '',
        county: data.county || '',
        state: data.state || '',
        zip: data.zip || '',
        streetaddress: data.streetaddress || '',
        city: data.city || '',
        roomaptnumber: data.roomaptnumber || '',
      }))
      .filter((sp: IServiceProvider) => sp.serviceproviderid != null);

    this.serviceProviderService.setServiceProviders(serviceProviderIds);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/service-provider/components/list-service-provider/list-service-provider.component.ts